import React, { useState, useEffect } from 'react';
import { useAPI } from '../../ApiCalls/useAPI';
import RemoveLastDirectoryPartOf from '../goBackButton';
import { Card, Table } from 'tabler-react';

export default function Arjuna() {
    const [data, setData] = useState([]);
    const { getArjuna } = useAPI();
    useEffect(() => {
        getArjuna()
            .then((response) => setData(response))
            .catch((error) => console.error(error));
        // console.log(data, 'arjuna');
    }, []);

    if (data.length === 0) {
        return (
            <div className="container">
                <div
                    className="m-2"
                    style={{ fontSize: '20px', display: 'flex' }}
                >
                    <div className="mr-4">
                        <a
                            href={RemoveLastDirectoryPartOf(
                                window.location.href
                            )}
                            style={{ textDecoration: 'none' }}
                        >
                            <i className="fe fe-arrow-left" />
                        </a>
                    </div>
                    <div>Arjuna</div>
                </div>
                <Card className="mt-4 p-4 text-center">Coming soon ...</Card>
            </div>
        );
    }
    return (
        <div className="container">
            <div className="m-2" style={{ fontSize: '20px', display: 'flex' }}>
                <div className="mr-4">
                    <a
                        href={RemoveLastDirectoryPartOf(window.location.href)}
                        style={{ textDecoration: 'none' }}
                    >
                        <i className="fe fe-arrow-left" />
                    </a>
                </div>
                <div>Arjuna</div>
            </div>
            <div>
                <Card
                    isCollapsible
                    title="This Week's competition"
                    body={
                        <div>
                            <Table>
                                <Table.Header>
                                    <Table.ColHeader>Q.no</Table.ColHeader>
                                    <Table.ColHeader>Grade</Table.ColHeader>
                                    <Table.ColHeader>
                                        Submissions
                                    </Table.ColHeader>
                                    <Table.ColHeader>
                                        Position in LEADER BOARD
                                    </Table.ColHeader>
                                </Table.Header>
                                <Table.Body>
                                    {data.result.map((item) => (
                                        <Table.Row>
                                            <Table.Col>1</Table.Col>
                                            <Table.Col>{item.grade}</Table.Col>
                                            <Table.Col>
                                                {item.submissions}
                                            </Table.Col>
                                            <Table.Col>{data.rank}</Table.Col>
                                        </Table.Row>
                                    ))}
                                </Table.Body>
                            </Table>
                        </div>
                    }
                />
                <Card
                    isCollapsible
                    title="Arjuna Track Record"
                    body={
                        <div>
                            <div
                                className="m-2"
                                style={{ fontSize: '16px', fontWeight: '600' }}
                            >
                                <div className="mb-2" style={{ float: 'left' }}>
                                    Total Competitions - {data.totalheld}
                                </div>
                                <div
                                    className="mb-2"
                                    style={{ float: 'right' }}
                                >
                                    Participated - {data.totalattempted}
                                </div>
                            </div>
                            <Table>
                                <Table.Header>
                                    <Table.ColHeader>
                                        1<sup>st</sup>
                                    </Table.ColHeader>
                                    <Table.ColHeader>
                                        2<sup>nd</sup>
                                    </Table.ColHeader>
                                    <Table.ColHeader>
                                        3<sup>rd</sup>
                                    </Table.ColHeader>
                                    <Table.ColHeader>
                                        4<sup>th</sup>
                                    </Table.ColHeader>
                                    <Table.ColHeader>
                                        5<sup>th</sup>
                                    </Table.ColHeader>
                                </Table.Header>
                                <Table.Body>
                                    <Table.Row>
                                        <Table.Col>{data.first}</Table.Col>
                                        <Table.Col>{data.second}</Table.Col>
                                        <Table.Col>{data.third}</Table.Col>
                                        <Table.Col>{data.fourth}</Table.Col>
                                        <Table.Col>{data.fifth}</Table.Col>
                                    </Table.Row>
                                </Table.Body>
                                <Table.Header>
                                    <Table.ColHeader>
                                        6<sup>th</sup>
                                    </Table.ColHeader>
                                    <Table.ColHeader>
                                        7<sup>th</sup>
                                    </Table.ColHeader>
                                    <Table.ColHeader>
                                        8<sup>th</sup>
                                    </Table.ColHeader>
                                    <Table.ColHeader>
                                        9<sup>th</sup>
                                    </Table.ColHeader>
                                    <Table.ColHeader>
                                        10<sup>th</sup>
                                    </Table.ColHeader>
                                </Table.Header>
                                <Table.Body>
                                    <Table.Row>
                                        <Table.Col>{data.sixth}</Table.Col>
                                        <Table.Col>{data.seventh}</Table.Col>
                                        <Table.Col>{data.eighth}</Table.Col>
                                        <Table.Col>{data.ninth}</Table.Col>
                                        <Table.Col>{data.tenth}</Table.Col>
                                    </Table.Row>
                                </Table.Body>
                            </Table>
                        </div>
                    }
                />
            </div>
        </div>
    );
}
